import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { TextVariant } from '@naf/text';
import { AnimateText, AnimateStatic } from '@naf/animation';
import { Caption, Header, ImageWrapper, Image, Ingress, StyledGridCol, StyledRunningHead, Wrapper, YellowLine } from './Styles';
export const FeatureHeader = /*#__PURE__*/forwardRef(({
  title,
  subText,
  runningHead,
  imageOrVideo,
  nafBranded = true,
  className,
  overlay,
  caption,
  clickThroughHeader
}, ref) => {
  const [subTextHeightValue, setSubTextHeightValue] = useState('0');
  const [mediaWidthValue, setMediaWidthValue] = useState('1400');
  const [videoHeightValue, setVideoHeightValue] = useState('');
  const [captionHeightValue, setCaptionHeightValue] = useState('');
  const ingressRef = useRef(null);
  const mediaRef = useRef(null);
  const captionRef = useRef(null);
  useEffect(() => {
    if (subText && ingressRef && ingressRef.current && typeof window !== 'undefined') {
      const ingressHeight = ingressRef.current.clientHeight;
      if (ingressHeight) setSubTextHeightValue(`${ingressHeight}`);
    }
  }, [subText]);
  useEffect(() => {
    if (caption && captionRef && captionRef.current && typeof window !== 'undefined') {
      const captionHeight = captionRef.current.clientHeight;
      if (captionHeight) setCaptionHeightValue(`${captionHeight}`);
    }
  }, [caption]);
  useEffect(() => {
    const currentMediaRef = mediaRef.current;
    function handleResize() {
      if (imageOrVideo && currentMediaRef && typeof window !== 'undefined') {
        const mediaWidth = currentMediaRef.clientWidth;
        let video;
        if (currentMediaRef.getElementsByTagName('video') && currentMediaRef.getElementsByTagName('video')?.length > 0) {
          video = currentMediaRef.getElementsByTagName('video');
        } else if (currentMediaRef.getElementsByTagName('iframe') && currentMediaRef.getElementsByTagName('iframe')?.length > 0) {
          video = currentMediaRef.getElementsByTagName('iframe');
        }
        const videoHeight = video && video?.length > 0 && video[0] && video[0].clientHeight;
        if (mediaWidth) setMediaWidthValue(`${mediaWidth}`);
        if (videoHeight) setVideoHeightValue(`${videoHeight}`);
      }
    }
    window.addEventListener('resize', handleResize);
    if (imageOrVideo && currentMediaRef) {
      let video;
      if (currentMediaRef.getElementsByTagName('video') && currentMediaRef.getElementsByTagName('video')?.length > 0) {
        video = currentMediaRef.getElementsByTagName('video');
      } else if (currentMediaRef.getElementsByTagName('iframe') && currentMediaRef.getElementsByTagName('iframe')?.length > 0) {
        video = currentMediaRef.getElementsByTagName('iframe');
      }
      if (video && video?.length > 0) {
        video[0].addEventListener('loadedmetadata', handleResize);
      }
    }
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
      if (imageOrVideo && currentMediaRef) {
        let video;
        if (currentMediaRef.getElementsByTagName('video') && currentMediaRef.getElementsByTagName('video')?.length > 0) {
          video = currentMediaRef.getElementsByTagName('video');
        } else if (currentMediaRef.getElementsByTagName('iframe') && currentMediaRef.getElementsByTagName('iframe')?.length > 0) {
          video = currentMediaRef.getElementsByTagName('iframe');
        }
        if (video && video?.length > 0) {
          video[0].removeEventListener('loadedmetadata', handleResize);
        }
      }
    };
  }, [imageOrVideo, overlay, mediaRef]);
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className,
    ref: ref,
    $subTextHeight: subTextHeightValue,
    $mediaWidth: mediaWidthValue,
    $videoHeight: videoHeightValue
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    $mediaWidth: mediaWidthValue,
    $videoHeight: videoHeightValue
  }, imageOrVideo && /*#__PURE__*/React.createElement(Image, {
    $mediaWidth: mediaWidthValue,
    $videoHeight: videoHeightValue,
    ref: mediaRef,
    $overlay: overlay
  }, imageOrVideo)), /*#__PURE__*/React.createElement(Header, {
    mediaWidth: mediaWidthValue,
    videoHeight: videoHeightValue,
    $clickThroughHeader: clickThroughHeader
  }, /*#__PURE__*/React.createElement(StyledGridCol, {
    s: "12",
    m: "12",
    l: "12",
    xl: "12",
    captionHeight: captionHeightValue
  }, runningHead && /*#__PURE__*/React.createElement(StyledRunningHead, {
    tag: "p",
    variant: TextVariant.Tag
  }, runningHead), /*#__PURE__*/React.createElement(AnimateText, {
    textProps: {
      variant: TextVariant.Header1
    }
  }, title), nafBranded && /*#__PURE__*/React.createElement(AnimateStatic, {
    delay: 600,
    timeout: 1000
  }, /*#__PURE__*/React.createElement(YellowLine, null))), subText && /*#__PURE__*/React.createElement(Ingress, {
    mediaWidth: mediaWidthValue,
    videoHeight: videoHeightValue,
    ref: ingressRef,
    variant: TextVariant.Ingress
  }, subText), caption && /*#__PURE__*/React.createElement(Caption, {
    ref: captionRef
  }, caption)));
});
//# sourceMappingURL=FeatureHeader.js.map